<template>
  <div class=" move-in-from-top">
    <a :href="sciallink" target="_blank" v-html="socialtext"></a>
  </div>
</template>
<script>
export default {
  name: "MenuSocial",
  props: ["sciallink", "socialtext", 'numb',],
  mounted() {
    let idcounter = this.numb + 5

    function menushow(el) {
      el.classList.add('start')
    }
    if (this.$store.state.isFirstLoad) {
      setTimeout(menushow, idcounter * 250, this.$el);
      if (idcounter === 9) {
        this.$store.commit('DisableFirstLoad');
      }
    } else {
      menushow(this.$el);
    }

  },
}
</script>

<style scoped>

</style>